// src/adminCalendar/nativeUi/useNativeInsets.js
// IMPORTANT: save as UTF-8 without BOM.

import { useEffect, useState } from "react";

/**
 * Computes a best-effort bottom inset for native runtimes (Capacitor)
 * to avoid Android 3-button navbar overlays and iOS safe-area issues.
 */
export default function useNativeInsets({ isNativeRuntime }) {
  const [nativeBottomInsetPx, setNativeBottomInsetPx] = useState(0);

  useEffect(() => {
    if (!isNativeRuntime) {
      setNativeBottomInsetPx(0);
      return;
    }

    const vv = typeof window !== "undefined" ? window.visualViewport : null;
    if (!vv) {
      setNativeBottomInsetPx(0);
      return;
    }

    const compute = () => {
      try {
        const bottom = Math.max(0, Math.round(window.innerHeight - vv.height - (vv.offsetTop || 0)));
        setNativeBottomInsetPx(Math.min(220, bottom));
      } catch {
        setNativeBottomInsetPx(0);
      }
    };

    compute();
    const raf = window.requestAnimationFrame ? window.requestAnimationFrame(compute) : null;
    vv.addEventListener("resize", compute);
    vv.addEventListener("scroll", compute);
    window.addEventListener("resize", compute);
    window.addEventListener("orientationchange", compute);

    return () => {
      if (raf && window.cancelAnimationFrame) window.cancelAnimationFrame(raf);
      vv.removeEventListener("resize", compute);
      vv.removeEventListener("scroll", compute);
      window.removeEventListener("resize", compute);
      window.removeEventListener("orientationchange", compute);
    };
  }, [isNativeRuntime]);

  return { nativeBottomInsetPx };
}